import { err, ok } from '@xlearn/common';
import { SchemaError, ErrorCode } from '../schema-engine';
import { Exit, parseExitString } from '../../api/exit';

export function setExit(current: Exit, value: string) {
  const parsed = parseExitString(value);
  if (!parsed.success) {
    return err(new SchemaError(ErrorCode.incorrectDataType, value));
  }

  return ok(parsed.value);
}

